export default {
  data() {
    return {
      assetRegisterImportLimit: 50,
      facilityRegisterImportLimit: 10,
      equipmentRegisterImportLimit: 10,
      materialRegisterImportLimit: 10,
      riskRegisterImportLimit: 10,
      hazardRegisterImportLimit: 10,
      actionRegisterImportLimit: 10
    };
  }
};
